import { useSelector } from 'react-redux';
import { getSelectedInsurances } from '../../../../Checkout/store/order/selectors';
import { hasPaidInsuranceByType } from './hasPaidInsuranceByType';
export const useHasPaidInsurances = (types) => {
    const selectedInsurances = useSelector(getSelectedInsurances);
    /* если есть policyNumber, то это страховка оплачена */
    return hasPaidInsuranceByType(selectedInsurances, types);
};
